
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent/[slug]",
      function () {
        return require("private-next-pages/talent/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent/[slug]"])
      });
    }
  